import React from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import { UploadImageSimpleField } from 'components/FormFieldsSimple/UploadImageSimpleField';
import { UPLOAD_URLS } from 'config/constants';
import { uploadFile } from 'utils/files/uploadFile';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

const staticInitial = {};

const NETWORK_ERROR_MESSAGE = 'Network error. Please try again.';

// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated This component is deprecated, please use src/components/FormFields/UploadImageField/UploadImageField.tsx instead.
 */
export class UploadImageField extends React.PureComponent {
  static propTypes = {
    ...fieldPropTypes,
    input: PropTypes.object,
    meta: PropTypes.object,
    allowedExtensions: PropTypes.array, // empty if all extensions is allowed
    allowedExtensionsErrorMessage: PropTypes.string,
    maxFileSize: PropTypes.number, // max MB
    maxFileSizeErrorMessage: PropTypes.string,
    uploadURL: PropTypes.string,
  };

  static defaultProps = {
    input: {},
    meta: {},
    allowedExtensions: [],
    allowedExtensionsErrorMessage: 'Incorrect image format',
    maxFileSize: Infinity,
    maxFileSizeErrorMessage: 'Image is too large',
    uploadURL: UPLOAD_URLS.images,
  };

  state = {
    item: {},
  };

  handleChange = (file) => {
    const { name, size } = file;

    let errorMessage = '';

    const { maxFileSize, maxFileSizeErrorMessage } = this.props;
    const isFileSizeAllowed = size / 1048576 <= maxFileSize;
    if (!isFileSizeAllowed) {
      errorMessage = maxFileSizeErrorMessage;
    }

    let imageUrl = '';
    const nameArray = name.split('.');
    const extension = nameArray[nameArray.length - 1].toUpperCase();
    const { allowedExtensions, allowedExtensionsErrorMessage } = this.props;
    const isExtensionAllowed = !allowedExtensions.length
      ? true
      : Boolean(
          allowedExtensions.find(
            (allowedExtension) => allowedExtension.toUpperCase() === extension,
          ),
        );
    if (!isExtensionAllowed) {
      errorMessage = allowedExtensionsErrorMessage;
    } else {
      imageUrl = '';
    }

    const { input } = this.props;
    input.onFocus();
    input.onChange({
      fileName: name,
      fileSize: size,
      status: isExtensionAllowed && isFileSizeAllowed ? 'LOAD' : 'ERROR',
      errorMessage,
      urls: {
        original: imageUrl,
      },
    });
    input.onBlur();

    if (!isExtensionAllowed || !isFileSizeAllowed) {
      return;
    }

    const { uploadURL } = this.props;

    uploadFile(
      uploadURL,
      file,
      () => {},
      this.completeLoading,
      this.errorLoading,
    );
  };

  completeLoading = (response) => {
    const { input = {} } = this.props;
    const { value = {} } = input;
    input.onChange({
      ...value,
      status: 'COMPLETE',
      name: response.name,
      keys: response.keys,
      urls: response.urls,
    });
  };

  errorLoading = () => {
    const { input = {} } = this.props;
    const { value = {} } = input;
    input.onChange({
      ...value,
      status: 'ERROR',
      errorMessage: NETWORK_ERROR_MESSAGE,
    });
  };

  render() {
    const { meta, input } = this.props;
    const { initial } = meta;

    const { value = {} } = input;
    const { urls = {}, status = '' } = value;
    const { small = '', medium = '', original = '' } = urls;

    return (
      <ReduxFormElementWrapper
        {...this.props}
        testId={`upload-image-${input.name}`}
        childrenMarginTop="14px"
        bottomErrorClassName="mt-4"
      >
        <UploadImageSimpleField
          {...this.props}
          onDrop={this.handleChange}
          initial={initial || staticInitial}
          isShowLoader={status === 'LOAD'}
          imageUrl={small || medium || original}
        />
      </ReduxFormElementWrapper>
    );
  }
}
